/* @flow strict */

import * as React from 'react';
import './styles.less';
import { ToggleOpacityOfContent } from '../../utils/animation';
import _ from 'lodash';

type PropsType = {
  completeStartRequest?: boolean
};

const logo = React.createRef();
const text = React.createRef();

const Preloader = ({ completeStartRequest }: PropsType): React.Element<typeof React.Fragment> => {
  if (completeStartRequest) {
    if (_.get(text, 'current.style', false) && _.get(logo, 'current.style', false)) {
      text.current.style.opacity = '0';

      logo.current.style.transform = 'scale(4)';
      logo.current.style.opacity = '0';
    }
  }

  React.useEffect(() => {
    ToggleOpacityOfContent(1);

    return () => {
      ToggleOpacityOfContent(0);
    };
  }, []);

  return (
    <div id="splash">
      <div className="content">
        <span className="sparxo-logo1" ref={logo} />
        <h1 ref={text}>Sparxo Ticketing</h1>
      </div>
    </div>
  );
};

export default Preloader;
